var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "module__container" },
    [
      _vm.controlVisible && _setup.hasSlotBtn
        ? _c(
            _setup.Portal,
            { attrs: { order: _vm.order, selector: _setup.btnTo } },
            [_vm._t("btn")],
            2
          )
        : _vm._e(),
      _vm._t("default"),
      _setup.c_containerId && _setup.hasSlotDraggable
        ? _c(
            _setup.Portal,
            { attrs: { selector: _setup.draggableTo } },
            [_vm._t("draggable", null, null, _setup.bindDrag)],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }